export default __webpack_public_path__ + "static/media/ic_telegram.af1a4a66.svg";